import { Button } from "@kaltura/ds-react-components";
import { useState } from "react";
import AddToPlaylistModal, { AddToPlaylistProps } from "./modal/AddToPlaylistModal";
import { ButtonClickAnalyticsType } from "@kaltura/mediaspace-shared-types";
import { useButtonAnalytics } from "@kaltura/mediaspace-shared-hooks";
import { Playlist24Icon } from "@kaltura/ds-react-icons";

/**
 * Add to playlist button for channel-edit manage-content tab
 */
export const AddToPlaylistButton = (props: AddToPlaylistProps) => {
    const { label, autoFocus, ...modalProps } = props;

    const [isOpen, setIsOpen] = useState<boolean>(false);

    const sendButtonAnalytics = useButtonAnalytics();

    const openAddToPlaylistModal = () => {
        sendButtonAnalytics("Media Actions - Add to Playlist", ButtonClickAnalyticsType.ADD);
        setIsOpen(true);
    };

    return (
        <>
            <Button
                variant={"borderless"}
                color={"secondary"}
                key={"add-to-playlist"}
                onClick={openAddToPlaylistModal}
                startIcon={<Playlist24Icon />}
            >
                {label}
            </Button>

            <AddToPlaylistModal {...modalProps} label={label} isOpen={isOpen} onCloseMenu={() => setIsOpen(false)} />
        </>
    );
};

export default AddToPlaylistButton;
